import { Button, Form, Icon, Label } from "semantic-ui-react";

import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import useBucket from "astrid-hooks/src/useBucket";

import Flex from "../../../../../components/Flex/Flex";
import { truncateMiddle } from "../../../../ui/utils/truncateString";

export default function DiscussionForm({ onComment }) {
	const { t } = useTranslation();

	const bucket = useBucket("earselect-uploads");
	const fileInputRef = useRef(null);

	const [text, setText] = useState("");
	const [files, setFiles] = useState([]);
	const [loading, setLoading] = useState(false);

	const onSend = async () => {
		setLoading(true);

		try {
			const now = Date.now();

			const attachments = await Promise.all(
				files.map(async (file, index) => {
					const { url } = await bucket.putFile(`discussions/${now}-${index}-${file.name}`, file);

					return { url, name: file.name };
				}),
			);

			await onComment({ text, attachments });

			setText("");
			setFiles([]);
		} finally {
			setLoading(false);
		}
	};

	const onSelectFiles = (e) => {
		const selected = Array.from(e.target.files ?? []);
		e.target.value = "";

		setFiles((current) => [...current, ...selected]);
	};

	const onRemoveFile = (index) => {
		setFiles((current) => current.filter((_, i) => i !== index));
	};

	return (
		<Form reply>
			<Form.TextArea
				style={{ height: 70 }}
				disabled={loading}
				onChange={(e) => setText(e.target.value)}
				value={text}
			/>

			<input ref={fileInputRef} type="file" multiple style={{ display: "none" }} onChange={onSelectFiles} />

			<Flex justifyContent="flex-start" gap={5} alignItems="center">
				<div>
					<Button icon circular type="button" disabled={loading} onClick={() => fileInputRef.current.click()}>
						<Icon name="attach" />
					</Button>
				</div>

				<Flex wrap justifyContent="flex-start" gap={5}>
					{files.map((file, index) => (
						<Label key={index} basic title={file.name}>
							{truncateMiddle(file.name)}

							<Icon name="delete" disabled={loading} onClick={() => onRemoveFile(index)} />
						</Label>
					))}
				</Flex>

				<Button
					content={t("send", "Send")}
					style={{ marginLeft: "auto" }}
					primary
					loading={loading}
					disabled={loading || !text}
					onClick={onSend}
				/>
			</Flex>
		</Form>
	);
}
